import { ReactNode } from 'react'

import { Layout } from 'antd'

import { LayoutHeader } from './Header'
import { LayoutMenu } from './Menu'
import { LayoutContent } from './Content'
import { LayoutSidebar } from './Sidebar'

import './index.css'

export interface AppLayoutProps {
  children: ReactNode
}

export const AppLayout = (props: AppLayoutProps) => {
  const { children } = props

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <LayoutHeader />
      <LayoutSidebar>
        <LayoutMenu />
      </LayoutSidebar>
      <Layout>
        <LayoutContent>{children}</LayoutContent>
      </Layout>
    </Layout>
  )
}
